export const SC_Constants = {
    projectProgress:"project-progress"
}